
import Cell from 'vux/src/components/cell/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'


export default {
name: "FastRepairOrder",
components: {Tab, TabItem, Group, Cell, XButton},
data(){
return{
dataList:[],
total:0,
type:'false',
isAdmin:true,
header: {
headers: {
token: localStorage.getItem('token'),
opid: localStorage.getItem('userid')
}
}
}
},
methods:{
pendingAdmin() {
this.dataList = [];
this.total = 0;
this.type = 'false';
this.$http.get('api/v1/fastrepairs?offset=0&count=10&closed=false', this.header).then(response => {
this.dataList = [...this.dataList, ...response.data.content]
this.total = response.data.total
})
},
processedAdmin() {
this.dataList = [];
this.total = 0;
this.type = 'true';
this.$http.get('api/v1/fastrepairs?offset=0&count=10&closed=true', this.header).then(response => {
this.dataList = [...this.dataList, ...response.data.content]
this.total = response.data.total
})
},
more(){
this.$http.get('api/v1/fastrepairs?offset=' + this.dataList.length + '&count=10&closed=' + this.type, this.header).then(response => {
this.dataList = [...this.dataList, ...response.data.content]
this.total = response.data.total
})
}
},
created() {
this.pendingAdmin();
}
}



// WEBPACK FOOTER //
// ./src/components/Administrator/FastRepairOrder.vue